import http from "@/http-common";

class AbsentLetterV3Service {
    async getAll({classId, gradeId, keyword, date, status, page, size}) {
        const params = {
            idClass: classId,
            gradeId: gradeId,
            date: date,
            status: status,
            keyword: keyword,
            page: page,
            size: size
        }

        return await http.get("/absent-letter-v4/list-by-school", {params});
    }

    async detail({id}) {
        return await http.get(`/absent-letter-v4/detail/${id}`);
    }

    approve({ids}) {
        const body = {
            ids: ids
        }
        return http.put("/absent-letter-v4/approve", body);
    }

    delete({ids}) {
        const body = {
            ids: ids
        }
        return http.delete("/absent-letter-v4/soft-delete", {data: body});
    }
}

export default new AbsentLetterV3Service();
